
export default function About() {
  return (
    <section id="about" className="py-12 bg-[#0d1b2e]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          プロジェクトマスターとは
        </h2>
        <div className="max-w-3xl mx-auto text-slate-300 space-y-3 text-sm md:text-base leading-relaxed">
          <p>
            プロジェクトマスターは
            AtZBusinessPartners株式会社が運営する
            フリーランスコンサルタント向け案件紹介サービスです。
          </p>
          <p>
            DX・戦略・業務改革などのプロジェクトに
            プロフェッショナル人材をマッチングしています。
          </p>
          <p>
            元請企業および上位会社の案件を中心に
            高額案件をご紹介しています。
          </p>
        </div>
      </div>
    </section>
  );
}
